import {
  getCrashEventsOverview,
  getCrashOverview,
  getCrashIdSummary,
  gethttpRequestsOverview,
  getHttpReqOverview,
  getHttpReqSummary,
  heatMapValues,
  getCrashInfoByCountry,
  getInfoByCountry,
  performanceHeatMapValues,
  performanceHeatMapValuesCompare,
  heatMapValuesMobileCompare,
  getPerformanceInfoByCountry,
  getPerformanceErrorOverview,
  getPerformanceErrorSummury,
  getDashCrashStats,
  getDashPerformanceStats,
  performanceErrorDetails,
  getDashDeviceUsageStats,
  getDashUsageKpisStats,
  crashDetailsSelectedCountry,
  performanceDetailsSelectedCountry
} from '@/services/graphQl/fragments/mobile';

export const queryGetCrashData = `query crashEvents(${getCrashOverview.variable}) {${getCrashOverview.query}}`;

export const queryGetCrashEventData = `query crashLogsSummary(${getCrashEventsOverview.variable}) {${getCrashEventsOverview.query}}`;

export const queryGetCashIDInfo = `query crashByID(${getCrashIdSummary.variable}) {${getCrashIdSummary.query}}`;

export const performanceErrorDetailsByID = `query performanceErrorDetailsByID(${performanceErrorDetails.variable}) {${performanceErrorDetails.query}}`;

export const queryGetHttpReqData = `query topHttpRequest(${getHttpReqOverview.variable}) {${getHttpReqOverview.query}}`;

export const queryGethttpRequestsData = `query performanceLogsSummary(${gethttpRequestsOverview.variable}) {${gethttpRequestsOverview.query}}`;

export const queryGetHttpReqInfo = `query endpointInfoMobile(${getHttpReqSummary.variable}) {${getHttpReqSummary.query}}`;

export const queryHeatMapValues = `query crashByCountry(${heatMapValues.variable}) {${heatMapValues.query}}`;

export const queryCrashInfoByCountry = `query crashInfoByCountry(${getCrashInfoByCountry.variable}) {${getCrashInfoByCountry.query}}`;

export const queryInfoByCountry = `query infoByCountry(${getInfoByCountry.variable}) {${getInfoByCountry.query}}`;

export const queryPerformanceHeatMapValues = `query performanceByCountry(${performanceHeatMapValues.variable}) {${performanceHeatMapValues.query}}`;

export const queryHeatMapValuesCompare = `query crashByCountry(${heatMapValuesMobileCompare.variable}) {${heatMapValuesMobileCompare.query}}`;

export const queryperformanceHeatMapValuesCompare = `query performanceByCountry(${performanceHeatMapValuesCompare.variable}) {${performanceHeatMapValuesCompare.query}}`;

export const queryPerformanceInfoByCountry = `query performanceInfoByCountry(${getPerformanceInfoByCountry.variable}) {${getPerformanceInfoByCountry.query}}`;

export const queryGetPerformanceErrorEventData = `query errorEvents(${getPerformanceErrorOverview.variable}) {${getPerformanceErrorOverview.query}}`;

export const queryGetPerformanceErrorEventSummuryData = `query performanceErrorSummary(${getPerformanceErrorSummury.variable}) {${getPerformanceErrorSummury.query}}`;

export const queryGetDashCrashStats = `query crashesKPIs(${getDashCrashStats.variable}) {${getDashCrashStats.query}}`;

export const queryGetDashPerformanceStats = `query crashesKPIs(${getDashPerformanceStats.variable}) {${getDashPerformanceStats.query}}`;

export const queryGetDeviceUsageStats = `query usagesInfoForMobileDashboard(${getDashDeviceUsageStats.variable}) {${getDashDeviceUsageStats.query}}`;

export const queryGetUsageKpisStats = `query usagesInfoForMobileDashboard(${getDashUsageKpisStats.variable}) {${getDashUsageKpisStats.query}}`;

export const queryCrashInfoSelectedCountry = `query crashByCountry(${crashDetailsSelectedCountry.variable}) {${crashDetailsSelectedCountry.query}}`;

export const queryPerformanceInfoSelectedCountry = `query crashByCountry(${performanceDetailsSelectedCountry.variable}) {${performanceDetailsSelectedCountry.query}}`;
